//Core
import React from "react"

//Styles
import style from "./style.module.scss"

const FooterItem = ({ title, link, list = [] }) => {
  return (
    <div>
      <div className={style.FooterItem}>
        <div className={style.title}>
          <a href={link} target="_blank" rel="noopener noreferrer">
            {title}
          </a>
        </div>

        <ul className={style.list}>
          {list.map(({ link, title }, index) => (
            <li key={link + index}>
              <a href={link} target="_blank" rel="noopener noreferrer">
                {title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default FooterItem
